import { render, staticRenderFns } from "./EditFactValueColumn.vue?vue&type=template&id=6ae051a6&scoped=true&"
import script from "./EditFactValueColumn.vue?vue&type=script&lang=js&"
export * from "./EditFactValueColumn.vue?vue&type=script&lang=js&"
import style0 from "./EditFactValueColumn.vue?vue&type=style&index=0&id=6ae051a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae051a6",
  null
  
)

export default component.exports